module.exports = __webpack_public_path__ + "img/Icon-Pfeil-runter-weis.782fba52.svg";